import { AdminExamLocationRoomComputerInfoDetails } from '@exam-center/admin-exam-center-location-details';
import { NavigateBackLinkWithHistory } from '@exam-center/components';
import { useParams } from '@exam-center/router';
import { Box, PageHeader, PaperSection } from '@shared/components';

export default function AdminExamCenterRoomComputerInfoPage() {
  const { roomId } = useParams('/admin/exam-location/locations/:roomId/computer-info');

  return (
    <>
      <PageHeader
        title='ข้อมูลเกี่ยวกับอุปกรณ์คอมพิวเตอร์'
        linkAdornment={
          <NavigateBackLinkWithHistory
            fallbackPath='/admin/exam-location/locations/:roomId'
            fallbackParams={{ roomId }}
            label='Back'
          />
        }
      />
      <Box sx={{ p: 6 }}>
        <PaperSection title='ข้อมูลเกี่ยวกับอุปกรณ์คอมพิวเตอร์'>
          <AdminExamLocationRoomComputerInfoDetails />
        </PaperSection>
      </Box>
    </>
  );
}
